// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivateLayout_mainContainer__sWA-7"};